import styled from 'styled-components'
import colors from '../utils/style/colors'

const Wrapper = styled.section`
  padding: 100px 48px;
  background: ${colors.blanc};
  text-align: center;
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    bottom: -80px; left: -80px;
    width: 400px; height: 400px;
    background: radial-gradient(circle, rgba(200,168,75,0.06) 0%, transparent 70%);
    pointer-events: none;
  }
  @media (max-width: 768px) { padding: 64px 20px; }
`
const SectionTag = styled.span`
  display: inline-block;
  color: ${colors.or};
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  font-family: ${colors.font};
  border-bottom: 2px solid ${colors.or};
  padding-bottom: 3px;
  margin-bottom: 14px;
`
const Title = styled.h2`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  font-weight: 700;
  color: ${colors.texte};
  margin-bottom: 12px;
`
const Sub = styled.p`
  font-size: 0.95rem;
  color: ${colors.texteLeger};
  margin-bottom: 56px;
  font-family: ${colors.font};
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.68;
`
const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 26px;
  max-width: 900px;
  margin: 0 auto;
  @media (max-width: 768px) { grid-template-columns: 1fr; gap: 16px; }
`
const InfoCard = styled.div`
  background: #fff;
  border: 1px solid ${colors.beigeFonce};
  border-radius: 8px;
  padding: 36px 28px;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 3px;
    background: linear-gradient(90deg, ${colors.vertOlive}, ${colors.or});
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s ease;
  }
  &:hover {
    box-shadow: 0 12px 40px rgba(58,90,46,0.12);
    transform: translateY(-5px);
    border-color: ${colors.or};
    &::after { transform: scaleX(1); }
  }
`
const CardIcon = styled.div`
  font-size: 2.4rem;
  margin-bottom: 18px;
`
const CardTitle = styled.div`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: ${colors.texte};
  margin-bottom: 10px;
`
const CardDesc = styled.div`
  font-size: 0.86rem;
  color: ${colors.texteLeger};
  line-height: 1.65;
  font-family: ${colors.font};
`
const CardHighlight = styled.div`
  display: inline-block;
  margin-top: 14px;
  background: ${colors.beige};
  color: ${colors.vertOlive};
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 2px;
  font-family: ${colors.font};
`

function DeliverySection() {
  return (
    <Wrapper>
      <SectionTag>Livraison</SectionTag>
      <Title>Livraison en Suisse simple et rapide</Title>
      <Sub>
        Nous desservons tous les cantons avec une gestion complète
        des formalités douanières. Vous n'avez qu'à réceptionner.
      </Sub>
      <CardsRow>
        <InfoCard>
          <CardIcon>📍</CardIcon>
          <CardTitle>Toute la Suisse couverte</CardTitle>
          <CardDesc>
            Du Valais à Zurich, nous livrons dans l'ensemble des cantons
            suisses, quelle que soit votre localisation.
          </CardDesc>
          <CardHighlight>🇨🇭 Tous cantons</CardHighlight>
        </InfoCard>
        <InfoCard>
          <CardIcon>⏱️</CardIcon>
          <CardTitle>Délai de 3 à 7 jours</CardTitle>
          <CardDesc>
            Un transport optimisé pour vous livrer dans les meilleurs délais,
            avec un suivi de votre commande.
          </CardDesc>
          <CardHighlight>🌾 Transport optimisé</CardHighlight>
        </InfoCard>
        <InfoCard>
          <CardIcon>📝</CardIcon>
          <CardTitle>Douane 100% incluse</CardTitle>
          <CardDesc>
            Toutes les formalités douanières France-Suisse sont prises en
            charge. Vous n'avez qu'à réceptionner votre livraison.
          </CardDesc>
          <CardHighlight>✔︎ Clé en main</CardHighlight>
        </InfoCard>
      </CardsRow>
    </Wrapper>
  )
}

export default DeliverySection
